import {
    Receipt, HandCoins, ArrowsClockwise, FileDoc, ShoppingCart,
    Lightning, Hourglass, CheckCircle,
} from "@phosphor-icons/react";

export const STATUS_STYLE = {
    Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Partial: "bg-amber-50 text-amber-700 border-amber-200",
    Unpaid: "bg-rose-50 text-rose-700 border-rose-200",
};

export const SEVERITY_STYLE = {
    high: "border-rose-300 bg-rose-50 text-rose-900",
    medium: "border-amber-300 bg-amber-50 text-amber-900",
    low: "border-slate-200 bg-slate-50 text-slate-700",
};

// Lifecycle event → visual treatment map
export const EVENT_VISUAL = {
    proposal_created: { Icon: FileDoc, ring: "border-indigo-200", bg: "bg-indigo-50", text: "text-indigo-700" },
    proposal_approved: { Icon: CheckCircle, ring: "border-indigo-300", bg: "bg-indigo-100", text: "text-indigo-800" },
    po_created: { Icon: ShoppingCart, ring: "border-slate-200", bg: "bg-slate-50", text: "text-slate-700" },
    po_finalized: { Icon: Lightning, ring: "border-amber-300", bg: "bg-amber-50", text: "text-amber-800" },
    invoice_raised: { Icon: Receipt, ring: "border-slate-300", bg: "bg-white", text: "text-slate-900" },
    payment_received: { Icon: HandCoins, ring: "border-emerald-300", bg: "bg-emerald-50", text: "text-emerald-700" },
    credit_note: { Icon: ArrowsClockwise, ring: "border-rose-300", bg: "bg-rose-50", text: "text-rose-700" },
    milestone_pending: { Icon: Hourglass, ring: "border-amber-200 border-dashed", bg: "bg-white", text: "text-amber-700" },
};

export const STATUS_BADGE_TONE = {
    Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Pending: "bg-amber-50 text-amber-700 border-amber-200",
    Overdue: "bg-rose-50 text-rose-700 border-rose-200",
};
